import { ShortLinkTagsEnum } from 'consts/data';
import { countSquareBrackets, isDefine } from 'helpers';
import { isArray, uniqueId } from 'lodash';

const transformByType = (arrays, type) => {
  const charSplitMapping = {
    [ShortLinkTagsEnum.dot]: '.',
    [ShortLinkTagsEnum.slash]: '/',
  };

  const result = arrays
    .map((el) => el.value)
    .join('')
    .split(charSplitMapping?.[type] || '/')
    .filter((el) => !!el);

  return result;
};

const genObjectShortLink = ({ type, value }) => {
  return {
    value,
    type,
    id: uniqueId(type),
  };
};

const separateTags = (tag) => {
  tag = tag.replaceAll('][', ']*[');
  return tag.split('*').filter((el) => !!el);
};

class ShortLinkTagsBuilderModel {
  static initialShortLinkTagFromResponse({ subDomainParts, pathParts }) {
    const domain = genObjectShortLink({ value: '[Your domain]', type: ShortLinkTagsEnum.domain });

    const subDomains = [];
    subDomainParts.forEach((tag) => {
      const dotObject = genObjectShortLink({ value: '.', type: ShortLinkTagsEnum.dot });

      //* In case [Tag1][Tag2]
      if (countSquareBrackets(tag) > 1) {
        separateTags(tag).forEach((t) => {
          const subDomainObject = genObjectShortLink({ value: t, type: ShortLinkTagsEnum.tag });
          subDomains.push(subDomainObject);
        });
        subDomains.push(dotObject);
      } else {
        const subDomainObject = genObjectShortLink({ value: tag, type: ShortLinkTagsEnum.tag });
        subDomains.push(subDomainObject);
        subDomains.push(dotObject);
      }
    });

    const paths = [];
    pathParts.forEach((tag) => {
      const slashObject = genObjectShortLink({ value: '/', type: ShortLinkTagsEnum.slash });

      //* In case [Tag1][Tag2]
      if (countSquareBrackets(tag) > 1) {
        paths.push(slashObject);
        separateTags(tag).forEach((t) => {
          const pathObject = genObjectShortLink({ value: t, type: ShortLinkTagsEnum.tag });
          paths.push(pathObject);
        });
      } else {
        const pathObject = genObjectShortLink({ value: tag, type: ShortLinkTagsEnum.tag });
        paths.push(slashObject);
        paths.push(pathObject);
      }
    });

    const result = [...subDomains, domain, ...paths];
    return result;
  }

  static parseShortLinkTagsToRequestBody(shortLinkTags) {
    let subDomainParts = [];
    let pathParts = [];

    if (isArray(shortLinkTags)) {
      const indexOfMainDomain = shortLinkTags.findIndex(
        (el) => el.type === ShortLinkTagsEnum.domain
      );
      //* Eg: [dot, dot, your-domain, path, path] -> It means dot always place left and path always place right
      //* So we will declare what is dot or path by define index Your-Domain
      if (isDefine(indexOfMainDomain)) {
        const subDomains = shortLinkTags
          .slice(0, indexOfMainDomain)
          .filter((el) => isDefine(el.value));
        const paths = shortLinkTags
          .slice(indexOfMainDomain + 1, shortLinkTags.length)
          .filter((el) => isDefine(el.value));
        /**
         * E.g: [
         *   {"value":"[Vehicle year]","type":"tag","id":"tag25"},
         *   {"value":"/","type":"slash","id":"slash26"},
         *   {"value":"[Random Code]","type":"tag","id":"tag27"},
         *   {"value":"[Vehicle model]","type":"tag","id":"tag28"}
         * ]
         * -->  ['[Vehicle year]', '[Random Code][Vehicle model]']
         */
        subDomainParts = transformByType(subDomains, ShortLinkTagsEnum.dot);
        pathParts = transformByType(paths, ShortLinkTagsEnum.slash);
      }
    }

    return {
      subDomainParts,
      pathParts,
    };
  }
}

export default ShortLinkTagsBuilderModel;
